import React, { useState } from "react";

const Container = ({
  children,
  className,
  maxHeight = false,
  fluid = false,
  style = {},
  ...rest
}) => {
  const [height, setHeight] = useState();
  const ref = React.useRef();

  React.useEffect(() => {
    if (maxHeight && ref.current) {
      setHeight(`calc(100vh-${jQuery(ref.current).position().top})`);
    }
  }, [maxHeight]);

  return (
    <div
      ref={ref}
      className={`container${fluid ? "-fluid" : ""}${className ? " " + className : ""}`}
      style={{ ...(height ? { height } : {}), ...style }}
      {...rest}
    >
      {children}
    </div>
  );
};

export default Container;
